/* Menopause Face guide page — interactions. Vanilla, idempotent, no deps. */
(function () {
  "use strict";

  function money(cents) {
    var fmt = (window.mfgMoneyFormat || "€{{amount}}");
    var amount = (cents / 100).toFixed(2).replace(".", ",");
    return fmt.replace("{{amount}}", amount).replace("{{amount_with_comma_separator}}", amount);
  }

  /* ---- Reveal on scroll ---- */
  function initReveal() {
    var els = document.querySelectorAll(".mfg-section .reveal:not([data-bound])");
    if (!els.length) return;
    if (!("IntersectionObserver" in window)) { els.forEach(function (el) { el.classList.add("in"); el.setAttribute("data-bound", "1"); }); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add("in"); io.unobserve(en.target); } });
    }, { rootMargin: "0px 0px -8% 0px", threshold: 0.05 });
    els.forEach(function (el) { el.setAttribute("data-bound", "1"); io.observe(el); });
  }

  /* ---- Product forms (hero + device cross-sell) ---- */
  function initForm(form) {
    if (form.getAttribute("data-bound")) return;
    form.setAttribute("data-bound", "1");
    var atc = form.querySelector("[data-atc-btn]");
    var consent = form.querySelector("[data-consent]");
    var jsonEl = form.querySelector("[data-variant-json]");
    var variants = [];
    try { variants = jsonEl ? JSON.parse(jsonEl.textContent) : []; } catch (e) { variants = []; }

    function syncConsent() {
      if (!consent || !atc) return;
      var ok = consent.checked;
      atc.disabled = !ok || atc.getAttribute("data-sold-out") === "1";
      form.setAttribute("data-consent-ok", ok ? "1" : "0");
    }
    if (consent) { consent.addEventListener("change", syncConsent); syncConsent(); }

    /* quantity */
    var qtyIn = form.querySelector("input[name='quantity']");
    form.querySelectorAll("[data-qty-dec]").forEach(function (b) { b.addEventListener("click", function () { if (!qtyIn) return; qtyIn.value = Math.max(1, (parseInt(qtyIn.value, 10) || 1) - 1); }); });
    form.querySelectorAll("[data-qty-inc]").forEach(function (b) { b.addEventListener("click", function () { if (!qtyIn) return; qtyIn.value = (parseInt(qtyIn.value, 10) || 1) + 1; }); });

    /* variant selects */
    var selects = form.querySelectorAll("[data-option-index]");
    if (selects.length && variants.length) {
      function update() {
        var chosen = [];
        selects.forEach(function (s) { chosen[parseInt(s.getAttribute("data-option-index"), 10)] = s.value; });
        var v = null;
        for (var i = 0; i < variants.length; i++) {
          var ok = true;
          for (var j = 0; j < variants[i].options.length; j++) { if (chosen[j] !== undefined && variants[i].options[j] !== chosen[j]) { ok = false; break; } }
          if (ok) { v = variants[i]; break; }
        }
        var idIn = form.querySelector("[data-variant-id]");
        if (!v) { if (atc) { atc.disabled = true; atc.setAttribute("data-sold-out", "1"); } return; }
        if (idIn) idIn.value = v.id;
        if (atc) { atc.setAttribute("data-sold-out", v.available ? "0" : "1"); atc.disabled = !v.available || (consent && !consent.checked); }
        form.querySelectorAll("[data-mfg-price]").forEach(function (el) { el.textContent = money(v.price); });
        form.querySelectorAll("[data-mfg-compare]").forEach(function (el) {
          if (v.compare_at_price && v.compare_at_price > v.price) { el.textContent = money(v.compare_at_price); el.style.display = ""; }
          else { el.style.display = "none"; }
        });
      }
      selects.forEach(function (s) { s.addEventListener("change", update); });
    }
  }
  function initForms() { document.querySelectorAll("form[data-mfg-form]").forEach(initForm); }

  /* ---- Remote submit buttons (final CTA, sticky bar) ---- */
  function initRemoteAdd() {
    document.querySelectorAll("[data-mfg-add]:not([data-bound])").forEach(function (btn) {
      btn.setAttribute("data-bound", "1");
      btn.addEventListener("click", function () {
        var id = btn.getAttribute("data-form") || "mfg-product-form";
        var form = document.getElementById(id);
        if (!form) return;
        var consent = form.querySelector("[data-consent]");
        if (consent && !consent.checked) {
          form.scrollIntoView({ behavior: "smooth", block: "center" });
          consent.focus();
          var wrap = consent.closest(".consent");
          if (wrap) { wrap.style.outline = "2px solid #A9603C"; setTimeout(function () { wrap.style.outline = ""; }, 1800); }
          return;
        }
        if (form.requestSubmit) form.requestSubmit(); else form.submit();
      });
    });
  }

  /* ---- Sticky bar: show once the hero ATC scrolls out ---- */
  function initSticky() {
    var bar = document.querySelector(".mfg-section .sticky:not([data-bound])");
    if (!bar) return;
    bar.setAttribute("data-bound", "1");
    var anchor = document.querySelector("#mfg-product-form [data-atc-btn]") || document.querySelector("#mfg-product-form");
    if (!anchor || !("IntersectionObserver" in window)) { bar.classList.add("show"); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { bar.classList.toggle("show", !en.isIntersecting && en.boundingClientRect.top < 0); });
    }, { threshold: 0 });
    io.observe(anchor);
  }

  /* ---- FAQ accordion ---- */
  function initFaq() {
    document.querySelectorAll(".mfg-section .faq-item:not([data-bound])").forEach(function (item) {
      item.setAttribute("data-bound", "1");
      var q = item.querySelector(".faq-q"), a = item.querySelector(".faq-a");
      if (!q || !a) return;
      q.addEventListener("click", function () {
        var open = item.classList.toggle("open");
        q.setAttribute("aria-expanded", open ? "true" : "false");
        a.style.maxHeight = open ? a.scrollHeight + "px" : "0px";
      });
    });
  }

  /* ---- Hero gallery ---- */
  function initGallery() {
    document.querySelectorAll("[data-mfg-gallery]:not([data-bound])").forEach(function (g) {
      g.setAttribute("data-bound", "1");
      var main = g.querySelector("[data-gallery-main]");
      var thumbs = Array.prototype.slice.call(g.querySelectorAll("[data-gallery-thumb]"));
      var dots = Array.prototype.slice.call(g.querySelectorAll("[data-gallery-dot]"));
      if (!main || thumbs.length < 2) return;
      var idx = 0;
      function show(i) {
        idx = (i + thumbs.length) % thumbs.length;
        var src = thumbs[idx].getAttribute("data-src"), alt = thumbs[idx].getAttribute("data-alt") || "";
        main.classList.add("swapping");
        var pre = new Image();
        pre.onload = function () { main.removeAttribute("srcset"); main.src = src; main.alt = alt; main.classList.remove("swapping"); };
        pre.onerror = function () { main.classList.remove("swapping"); };
        pre.src = src;
        thumbs.forEach(function (t, k) { t.classList.toggle("active", k === idx); t.setAttribute("aria-selected", k === idx ? "true" : "false"); });
        dots.forEach(function (d, k) { d.classList.toggle("active", k === idx); });
        var active = thumbs[idx];
        if (active.scrollIntoView) { try { active.scrollIntoView({ block: "nearest", inline: "nearest", behavior: "smooth" }); } catch (e) {} }
      }
      thumbs.forEach(function (t, k) { t.addEventListener("click", function () { show(k); }); });
      var prev = g.querySelector("[data-gallery-prev]"), next = g.querySelector("[data-gallery-next]");
      if (prev) prev.addEventListener("click", function () { show(idx - 1); });
      if (next) next.addEventListener("click", function () { show(idx + 1); });
      g.querySelectorAll("img").forEach(function (im) { im.setAttribute("draggable", "false"); im.addEventListener("dragstart", function (e) { e.preventDefault(); }); });
      var sx = null, sy = null;
      var area = g.querySelector(".gallery-main");
      area.addEventListener("touchstart", function (e) { sx = e.touches[0].clientX; sy = e.touches[0].clientY; }, { passive: true });
      area.addEventListener("touchend", function (e) {
        if (sx === null) return;
        var dx = e.changedTouches[0].clientX - sx, dy = e.changedTouches[0].clientY - sy;
        sx = sy = null;
        if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) show(dx < 0 ? idx + 1 : idx - 1);
      }, { passive: true });
      g.addEventListener("keydown", function (e) { if (e.key === "ArrowLeft") show(idx - 1); if (e.key === "ArrowRight") show(idx + 1); });
    });
  }

  function init() { initReveal(); initForms(); initRemoteAdd(); initSticky(); initFaq(); initGallery(); }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", init); else init();
  document.addEventListener("shopify:section:load", init);
})();
